export default __webpack_public_path__ + "static/media/A1_5.c778b3af.png";